import { render, staticRenderFns } from "./user-type.vue?vue&type=template&id=17483983&"
import script from "./user-type.vue?vue&type=script&lang=js&"
export * from "./user-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports